/**
 * @file_purpose  component created for auth (login and register) modal
 * @author Swarnali Ghosh
 * @Date_Created 22-01-2025
 * @Date_Modified 22-01-2025
 */

import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Modal from "react-bootstrap/Modal";
import GeneralService from '../../apis/GeneralService';
import ApiURL from '../../apis/ApiURL';
import Constants from '../../utility/Constants';
import { toast } from 'react-toastify';
import { storeUserDetails, selectLanguage } from '../../redux/slices/UserDetailSlice.js';
import Loader from '../commonComp/Loader.jsx';
import { FormattedMessage } from "react-intl";
import { createMd5hashFun } from '../../utility/createHash';


const AuthModal = ({ authType, handleChangeAuthType, showAuthModal, handleModeChangeAuthModal }) => {


  // const currencyList = useSelector((state) => state.currencyState.currency_list);
  const languageState = useSelector((state) => state.languageState);
  let languageCode = languageState.active_language.language_code;

  const dispatch = useDispatch();

  const [state, setState] = useState({
    username: "",
    password: "",
    client_id: process.env.REACT_APP_CLIENT_ID || "683059b54a3eeeaad7ee3f18",
    account_id: "",
    account_list: []
  });

  const [usernameErrors, setUsernameErrors] = useState("");
  const [passwordErrors, setPasswordErrors] = useState("");
  const [accountErrors, setAccountErrors] = useState("");

  const [loadingState, setLoadingState] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [submitDisable, setSubmitDisable] = useState(false);
  const userDetailState = useSelector((state) => state.userDetailState);


  const closeAuthModal = () => {
    setState(prevState => ({
      ...prevState,
      password: "",
      username: "",
      // account_id: ""
    }))

    setUsernameErrors("")
    setPasswordErrors("")
    setAccountErrors("")

    handleModeChangeAuthModal()
  }

  const handleChange = (e) => {
    const { id, value } = e.target
    setState(prevState => ({
      ...prevState,
      [id]: value
    }))
  }

  /**
* @author Swarnali Ghosh
* @Date_Created 07-03-2024
* @Date_Modified 13/03/2023
* @function async
* @functionName loadAccountList
* @functionPurpose this function gets account list.
* @functionParam {}
* @functionSuccess Success status and message.
* @functionError {Boolean} error is there.
* @functionError {String} message  Description message.
*/

  async function loadAccountList() {

    let params = JSON.stringify({
      "client_id": state?.client_id
    })

    GeneralService.apiPostCallRequest(`${ApiURL.accountList}`, params).then(res => {

      if (res.err == Constants.API_RESPONSE_ERROR_FALSE) {

        setState(prevState => ({
          ...prevState,
          account_list: res?.data
        }))
      }

    }).catch(error => {
    })

  }

  useEffect(() => {

    loadAccountList()

  }, [])


  /* Validation Checking */
  const ValidateForm = (e) => {
    e.preventDefault();
    if (handleValidation()) {
      AuthSubmitClick();
    }
    else {
      toast.error(<FormattedMessage id='PLEASEFILLALLFIELDS' />, {
        position: "bottom-right",
      })
    }
  }

  /* Validate all fields */
  const handleValidation = (e) => {
    let accountErrors, usernameErrors, passwordErrors;
    const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    let formIsValid = true;

    if (!state.username) {
      formIsValid = false;
      usernameErrors = <FormattedMessage id='USERNAMECANNOTBEEMPTY' />;
      setUsernameErrors(usernameErrors);
    } else {
      setUsernameErrors('');
    }

    if (!state.account_id) {
      formIsValid = false;
      accountErrors = <FormattedMessage id='ACCOUNTCANNOTBEEMPTY' />;
      setAccountErrors(accountErrors);
    } else {
      setAccountErrors('');
    }

    if (!state.password) {
      formIsValid = false;
      passwordErrors = <FormattedMessage id='PASSWORDCANNOTBEEMPTY' />;
      setPasswordErrors(passwordErrors);
    } else {
      setPasswordErrors('');
    }

    return formIsValid;
  }

  /**
 * @author Swarnali Ghosh
 * @Date_Created 22/01/2025
 * @Date_Modified 24/01/2025
 * @function async
 * @functionName AuthSubmitClick
 * @functionPurpose this function use for login.
 * @functionParam {payload object: username, password }
 * @functionSuccess Success status and message.
 * @functionError {Boolean} error is there.
 * @functionError {String} message  Description message.
 */

  const AuthSubmitClick = async (e) => {

    setLoadingState(true)
    let params = JSON.stringify({
      client_id: state.client_id,
      username: state.username,
      account_id: state.account_id,
      password: state.password
    })

    GeneralService.apiPostCallRequest(ApiURL.login, params).then(res => {

      if (res.err == Constants.API_RESPONSE_ERROR_FALSE && res?.message == "Valid Player") {

        setLoadingState(false);

        dispatch(storeUserDetails(res.data))
        dispatch(selectLanguage("en"))
        closeAuthModal();
        toast.success(res.message, {
          position: "bottom-right",
        })

      } else {
        setLoadingState(false);
        toast.error(res.message, {
          position: "bottom-right",
        })
      }
    }).catch(error => {
      setLoadingState(false);
      console.log(error);
    })

  }


  useEffect(() => {
    // console.log('ok', userDetailState?.user_details?.account_id);

    if (userDetailState?.user_details?.account_id != undefined) getBalanceDetails()
  }, [userDetailState?.user_details?.account_id != undefined]);

  /**
  * @author Sarmistha Mondal
  * @Date_Created  12.02.2025
  * @Date_Modified 
  * @function sync
  * @functionName getBalanceDetails
  * @functionPurpose this function for get balance.
  *
  * @functionParam {payload object: account_id ,client_id, player_id, hash_token}
  * 
  * @functionSuccess Success status and message.
  *
  * @functionError {Boolean} error error is there.
  * @functionError {String} message  Description message.
  */

  const getBalanceDetails = () => {
    let req_body = {
      "account_id": userDetailState?.user_details?.account_id,
      "client_id": state.client_id,
      "player_id": userDetailState?.user_details?.player_id,
    }

    let generatedHash = createMd5hashFun(req_body, userDetailState?.user_details?.account_key || '');

    let params = JSON.stringify({
      "player_id": userDetailState?.user_details?.player_id,
      "client_id": state.client_id,
      "account_id": userDetailState?.user_details?.account_id,
      "hash_token": generatedHash,
    })

    toast.dismiss();
    GeneralService.apiPostCallRequest(ApiURL.getPlayerBalance, params)
      .then((res) => {
        if (res.err === Constants.API_RESPONSE_ERROR_FALSE) {

          let available_balance = res.data.available_balance;
          let getUserData = { ...userDetailState?.user_details, available_balance }
          dispatch(storeUserDetails(getUserData))


        } else {
          toast.error(res.message, {
            position: 'bottom-right',
            autoClose: false,
          });
        }
      })
      .catch((error) => {

        // console.log(error);
        if (error?.response?.status === 400) {
          toast.error(error.response.data.message, {
            position: 'bottom-right',
            autoClose: false,
          });
        } else if (error?.response?.status === 404) {
          toast.error(error.response.data.message, {
            position: 'bottom-right',
            autoClose: false,
          });
        } else {
          console.error('getBalanceDetails network error:', error.message);
        }
      });
  }

  return (
    <>
      <Modal
        show={showAuthModal}
        onHide={closeAuthModal}
        backdrop="static"
        centered
      >
        <div className="apply_comp_sec">
          <Loader loadingStatus={loadingState} />
          <Modal.Header closeButton className='py-3'>
            <h6 className="hed_txt m-0">{authType == "login" ?
              <FormattedMessage id='LOGIN' />
              : ""}</h6>
          </Modal.Header>

          <div className="">
            <div className="">
              <div className="row login-register-form">

                <div className="col-md-12 input-display"
                // hidden={authType == "login" ? true : false}
                >

                  <label htmlFor="username">
                    <FormattedMessage id='USERNAME' />
                    <span className='v-error'>  * </span></label>
                  <input
                    id="username"
                    placeholder={languageCode == "en" ? "Enter username" : "이름을 입력하시오"}
                    value={state.username}
                    onChange={handleChange}
                  />
                  <span className='v-error'>{usernameErrors}</span>
                </div>


                <div className="col-md-12 input-display"
                // hidden={authType == "login" ? true : false}
                >

                  <label htmlFor="account_id">
                    <FormattedMessage id='ACCOUNT' />
                    <span className='v-error'>  * </span></label>
                  <select id='account_id' name='account_id'
                    value={state.account_id} onChange={handleChange}
                  >
                    <option value="" ><FormattedMessage id='SELECTACCOUNT' /></option>
                    {state.account_list?.length > 0 ? state.account_list.map((item, keyIndex) => {
                      return <option key={keyIndex} value={item._id}>{item.account_name}</option>
                    }) : ""}
                  </select>
                  <span className='v-error'>{accountErrors}</span>
                </div>

                <div className="col-md-12 input-display showHidePass">

                  <label htmlFor="password" >
                    <FormattedMessage id='PASSWORD' />
                    <span className='v-error'> * </span></label>

                  <input
                    type={showPassword === true ? "text" : "password"}
                    id="password"
                    placeholder={languageCode == "en" ? "Enter password" : "암호를 입력"}
                    value={state.password}
                    onChange={handleChange}
                  />
                  <div className="input-group-addon">
                    <i className={`fa ${showPassword === true ? "fa-eye" : "fa-eye-slash"} `} aria-hidden="true"
                      onClick={() => { setShowPassword(!showPassword) }}
                    ></i>
                  </div>

                  <span className='v-error'>{passwordErrors}</span>
                </div>


              </div>
            </div>
          </div>


          <div className="row">
            <div className="col-md-10 offset-md-1 save-cancel-btn">
              <button
                disabled={submitDisable ? true : false}
                className="save_btn" style={{ marginRight: 10 }}
                onClick={ValidateForm}
              >
                <FormattedMessage id='SUBMIT' />
              </button>
              <button className="cancel_btn"
                onClick={closeAuthModal}
              >
                <FormattedMessage id='CANCEL' />
              </button>
            </div>
          </div>

        </div>
      </Modal>
    </>
  )
}

export default AuthModal
